var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardPartnership(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "547C875C-D21D-4B44-ADF0-07BD928D12B1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contact-us",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact-us---General",
    transform: "translate(-270.000000, -608.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-3",
    transform: "translate(250.000000, 588.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card_partnership",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8333333,27.0833333 L45.8333333,18.75 C45.8333333,8.33333333 41.6666667,4.16666667 31.25,4.16666667 L18.75,4.16666667 C8.33333333,4.16666667 4.16666667,8.33333333 4.16666667,18.75 L4.16666667,31.25 C4.16666667,41.6666667 8.33333333,45.8333333 18.75,45.8333333 L27.0833333,45.8333333",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2709961,30.1870346 L20.2293396,23.7495104 C20.9376729,22.8328438 22.2501806,22.6661924 23.1668472,23.3745257 L26.9793828,26.3745308 C27.8960495,27.0828641 29.2084935,26.9162013 29.9168269,26.0203679 L34.7293854,19.8120117",
    id: "Vector",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(31.239827, 31.255086)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92729366,2.89060846 C10.2189603,3.4739418 10.9481016,4.01562118 11.5939349,4.14062118 L12.3856117,4.26561634 C14.7606117,4.66144967 15.3231041,6.41145098 13.6147708,8.14061761 L12.8855914,8.8697652 C12.4064247,9.36976519 12.1356372,10.3281075 12.2814705,10.9947741 L12.3856117,11.4322881 C13.0314451,14.3072881 11.510622,15.4114281 9.01062191,13.9114281 L8.46893489,13.5989408 C7.82310156,13.2239408 6.78144507,13.2239408 6.13561173,13.5989408 L5.59392472,13.9114281 C3.07309131,15.4322614 1.55226824,14.3072881 2.21893489,11.4322881 L2.32307613,10.9947741 C2.46890946,10.3281075 2.19812179,9.36976519 1.71895511,8.8697652 L0.989775732,8.14061761 C-0.718557586,6.41145098 -0.156065077,4.66144967 2.21893489,4.26561634 L3.01061173,4.14062118 C3.63561176,4.03645451 4.3855863,3.4739418 4.67725297,2.89060846 L5.26058376,1.70312499 C6.3855838,-0.567708413 8.21896282,-0.567708413 9.34396287,1.70312499 L9.92729366,2.89060846 Z",
    id: "Vector"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50,0 L50,50 L0,50 L0,0 L50,0 Z",
    id: "Vector",
    opacity: 0
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPartnership);
export default __webpack_public_path__ + "static/media/card_partnership.cde06f55c6b040112d7e04e10424a400.svg";
export { ForwardRef as ReactComponent };